import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

@observer
class DeleteInstallation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            installation: {},
            isLoading: true,
            isDeleting: false,
            deleteError: '',
        };
    }

    loadAll = async (props = this.props) => {
        const { id } = props;
        const { installationStore } = this.props.stores;
        this.setState({ isLoading: true, deleteError: '' });
        const installations = await installationStore.load(id, false, { skipUpdate: true });
        this.setState({ installation: installations?.[0] || {}, isLoading: false });
    }

    deleteInstallation = async () => {
        const { callback = () => {}, drawerLevel = 1 } = this.props;
        const { installation } = this.state;
        const { appState, installationStore } = this.props.stores;
        this.setState({ isDeleting: true, deleteError: '' });
        const response = await installationStore.remove(installation.id);
        if (response?.status === 202) {
            this.setState({ isDeleting: false });
            appState.toggleDrawer(false, drawerLevel);
            callback();
            return;
        }
        this.setState({ isDeleting: false, deleteError: response?.message || 'Could not delete installation' });
    }

    toggleDrawer = () => {
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        appState.toggleDrawer(false, drawerLevel);
    }

    componentDidMount() {
        this.loadAll();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== this.props.id) {
            this.loadAll(nextProps);
        }
    }

    render() {
        const { installation, isLoading, isDeleting, deleteError } = this.state;
        const hasParts = installation.parts?.length > 0;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header'>
                        <Text id='installation.delete'>Delete installation</Text>
                    </div>

                    <div class='w-100 d-flex flex-column px-3'>
                        <div class='card'>
                            <div class='card-body' style='font-size: 1.2em;'>
                                {isLoading ? <i class='fa-solid fa-spinner fa-spin' /> : installation.name}
                            </div>
                        </div>
                    </div>

                    <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3'>
                        {!!deleteError && <div class='alert alert-danger py-2'>{deleteError}</div>}
                        {!isLoading && hasParts && <div class='alert alert-warning py-2'>
                            <Text id='installation.delete-has-parts'>Remove or move all parts before deleting this installation.</Text>
                        </div>}
                        <div class='d-flex flex-row flex-wrap'>
                            {!isLoading && !hasParts && installation.id > 0 && <button type='button' class='btn btn-danger flex-fill rounded-pill me-2' disabled={isDeleting} onClick={this.deleteInstallation}>
                                {isDeleting && <i class='fa-solid fa-spinner fa-spin me-2' />}
                                <Text id='installation.delete-confirm'>Confirm delete</Text>
                            </button>}
                            <button type='button' class='btn btn-secondary flex-fill rounded-pill' disabled={isDeleting} onClick={this.toggleDrawer}>
                                <Text id='installation.delete-cancel'>Cancel</Text>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}

export default DeleteInstallation;
